import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


const MOCK_USERDATA = {
  idUsuario: "soporte-clientes@gestionatupyme.cl",
  idOrganizacion: "DESARROLLO"
}

@Injectable({
  providedIn: 'root'
})
export class ActualizarCredencialesEndpointsService {

  private authUrl =
    "https://9hb2i5qas5.execute-api.us-east-1.amazonaws.com/DEV/authorization2";
  constructor(private _http: HttpClient) { }

  public validarSii(userName: string, rut: string, sii: string) {
    const headers = new HttpHeaders()
      .set("IDOrganization", `${rut}`);

    const body =
      {
        "idOrganizacion": rut,
        "service": "SII",
        "idUsuario": userName,
        "requestOrigin": "STS",
        "password": sii,
        "user": rut,
        // "servicio": "css",
        // "uri": "validarCredenciales"
    }

    //Llevar URL a environment
    return this._http.post<any>(`${environment.backend.main}/SecretInteraction/validarCredenciales`,  body, { headers: headers } ).pipe(
      map((res) => {
        return res;
      }));
  }

  public actualizarSii(userName: string, rut: string, sii: string) {

    const headers = new HttpHeaders()
      .set("IDOrganization", `${rut}`);

    //HACER UN MAPPER
    const body = {
      idUsuario: userName,
      // idUsuario: "TEST@",
      idOrganizacion: rut,
      rut: rut,
      requestOrigin: "WEB", //pasar a variable global
      services: [
        {
            name: "SII",
            attributes: [
                {
                    name: "userName",
                    value: rut
                },
                {
                    name: "password",
                    value: sii
                },
                {
                    name: "orgAccess",
                    value: "true"
                },
                {
                    name: "otherOrgAccess",
                    value: ""
                }
            ]
        },
      ]
    }

    // console.log(body)
    // console.log(headers)
    //Llevar URL a environment
    return this._http.post<any>(`${environment.backend.main}/SecretInteraction/crearActualizarSecretoUsuario`,  body, { headers: headers } )
  }
}

